import { makeStyles, Stack } from '@fluentui/react';
import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { FeatureToggles } from 'src/core/utils/featureToggles';

const messages = defineMessages({
    maintenanceNoticeText: {
        id: 'languageStudio.maintenance.banner.text',
        defaultMessage: 'Maintenance notice: starting {maintenanceDateWindow}, Language Studio will be unavailable.'
    }
});

const useStyles = makeStyles({
    container: {
        padding: '12px 20px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#FFF4CE',
        color: '#8A4700',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: '600',
        display: 'block'
    }
});

const LanguageStudioMaintenanceBanner = () => {
    const styles = useStyles();
    const shouldShowMaintenanceBanner = FeatureToggles.LanguageStudioMaintenanceBanner ?? false;
    const maintenanceDateWindow = FeatureToggles.LanguageStudioMaintenanceDateWindow ?? 'Monday 2/23/2025, 3 PM PST to 7 PM PST';

    if (!shouldShowMaintenanceBanner) {
        return null;
    }

    return (
        <Stack className={styles.container}>
            <FormattedMessage {...messages.maintenanceNoticeText} values={{ maintenanceDateWindow }} />
        </Stack>
    );
};

export default LanguageStudioMaintenanceBanner;
